import { useEffect, useState } from "react";
import { LoginRegistersService } from "../../../../_services/loginregisters.service";
import styled from "styled-components";
import { Tabla } from "../../../../components/Table/Table";
import DownloadExcel from "./DownloadExcel";

const ListRegUser = ({ userData, setShowModal }) => {
  const [dataDecorated, setDataDecorated] = useState([]);

  useEffect(() => {
    const getData = async () => {
      let res = await LoginRegistersService.getRegistersByDni(userData.dni);
      const dateDecorated = dataDecorator(res);
      setDataDecorated(dateDecorated);
    };
    getData();
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  const columns = [
    {
      title: "",
      dataIndex: "pos",
    },
    {
      title: "Fecha",
      dataIndex: "date",
    },
    {
      title: "Hora",
      dataIndex: "hour",
    },
  ];

  const columnsExcel = [
    {
      title: "",
      dataIndex: "pos",
    },
    {
      title: "Nombre y Apellido",
      dataIndex: "nomApe",
    },
    {
      title: "Fecha",
      dataIndex: "date",
    },
    {
      title: "Hora",
      dataIndex: "hour",
    },
  ];

  const dataDecorator = (arrayData = []) => {
    try {
      return arrayData.map((item, idx) => {
        const completeDate = new Date(item.fech_hor_login);
        const date = `${completeDate.getDate().toString().padStart(2, "0")}/${(completeDate.getMonth()+1).toString().padStart(2, "0")}/${completeDate.getFullYear()}`;
        const hour = `${completeDate.getHours().toString().padStart(2, "0")}:${completeDate.getMinutes().toString().padStart(2, "0")}:${completeDate.getSeconds().toString().padStart(2, "0")}`;
        return {
          nomApe: userData.nomApe,
          date: date,
          hour: hour,
          pos: idx,
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <Backdrop>
      <Modal>
        <Title className="text-center mb-4">Registros Login de {userData.nomApe}</Title>
        <DataContainer>
          <TextContainer>
            <Text>DNI: {userData.dni}</Text>
            <Text>Rol: {userData.rol}</Text>
            <Text>Tipo de Usuario: {userData.tipoUsuario}</Text>
          </TextContainer>
          <TextContainer>
            <Text>Código Externo: {userData.codigoExterno}</Text>
            <Text>Cantidad de Login: {userData.cantidadLogin}</Text>
          </TextContainer>
          <DownloadExcelButton>
            <DownloadExcel data={dataDecorated} columns={columnsExcel} nameFile={`registros_logs_${userData.nomApe}_${new Date().getTime()}.xlsx`}/>
          </DownloadExcelButton>
        </DataContainer>
        {dataDecorated ? <Tabla dataList={dataDecorated} columns={columns} /> : null}
        <CloseButton onClick={() => closeModal()}>Cerrar</CloseButton>
      </Modal>
    </Backdrop>
  );
};

export default ListRegUser;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* Fondo semitransparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1010;
  max-width: 1280px;
  width: 1280px;
  height: 95%;
`;

const Title = styled.h3 `
  font-weight: 700;
  font-size: 28px;
  color: #3E4345;
`;

const DataContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-around;
  justify-content: space-around;
  width: 75%;
  padding: 1.5rem;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
`;

const Text = styled.p`
  padding: 3px;
  font-size: 20px;
`;

const DownloadExcelButton = styled.div`
  width: 200px;
  height: 50px;
  margin-top: 20px;
  padding: 10px 20px;
  color: #F6F5F5;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
`;

const CloseButton = styled.button`
  width: 200px;
  height: 50px;
  margin-top: 20px;
  padding: 10px 20px;
  background: #ff4d4d;
  color: #F6F5F5;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;

  &:hover {
    background: #e43e3e;
  }
`;

